import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { timeDifferenceApprox } from 'src/app/utils/time-utils';

export enum SHARE_LENGTH {
  DAY = 'day',
  WEEK = 'week',
  TWOWEEKS = 'twoweeks',
  MONTH = 'month',
  THREEMONTHS = 'threemonths',
}

@Component({
  selector: 'app-public-share-card',
  templateUrl: './public-share-card.component.html',
  styleUrls: ['./public-share-card.component.scss'],
})
export class PublicShareCardComponent implements OnChanges {
  @Input() isPublic: boolean;
  @Input() isUserLogged: boolean;
  @Input() contentType: string = 'content';
  @Input() shareExpiration: string;
  @Input() isDisabled: boolean = false;
  @Input() backgroundColor: string = 'white';
  @Input() verticalLayout: boolean;
  @Output() setPublic: EventEmitter<{
    checked: boolean;
  }> = new EventEmitter();
  @Output() updateExpiration: EventEmitter<{ share_expiry: number }> =
    new EventEmitter();

  SHARE_LENGTH = SHARE_LENGTH;
  currentShareLength = SHARE_LENGTH.THREEMONTHS;
  inChangeState: boolean = false;
  expirationDisplay: string = 'not_initiated';
  periodLength = {
    day: 24 * 3600 * 1000,
    week: 24 * 3600 * 1000 * 7,
    twoweeks: 24 * 3600 * 1000 * 14,
    month: 24 * 3600 * 1000 * 31,
    threemonths: 24 * 3600 * 1000 * 31 * 3,
  };

  /**
   * Toggles the simulation state from public to private.
   * @param event
   */
  public togglePublic(event: MatButtonToggleChange) {
    this.inChangeState = true;
    this.setPublic.emit({
      checked: event.value,
    });
  }

  /**
   * Updates the current public simulation's expiration date.
   * @param shareLength:SHARE_LENGTH
   */
  public setExpiration(shareLength: SHARE_LENGTH) {
    this.inChangeState = true;
    let expiration = 0;
    switch (shareLength) {
      case SHARE_LENGTH.DAY:
        expiration = this.periodLength.day;
        break;
      case SHARE_LENGTH.WEEK:
        expiration = this.periodLength.week;
        break;
      case SHARE_LENGTH.TWOWEEKS:
        expiration = this.periodLength.twoweeks;
        break;
      case SHARE_LENGTH.MONTH:
        expiration = this.periodLength.month;
        break;
      case SHARE_LENGTH.THREEMONTHS:
        expiration = this.periodLength.threemonths;
        break;
      default:
        break;
    }
    this.updateExpiration.emit({ share_expiry: expiration });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isPublic) {
      this.isPublic = Boolean(changes.isPublic.currentValue);
      this.inChangeState = false;
    }
    if (changes.shareExpiration) {
      this.expirationDisplay = timeDifferenceApprox(
        new Date(this.shareExpiration).getTime(),
        Date.now()
      );
      this.inChangeState = false;
    }
    if (
      // Check that we actually have a change in the expiration date.
      // Avoids the expiration date defaulting to "1 Day" when other properties
      // change (changes.isPublic && shareExpiration === undefined)
      changes.shareExpiration &&
      (changes.shareExpiration?.firstChange || !changes.isPublic?.firstChange)
    ) {
      this.currentShareLength = this.getCurrentExpirationRangẹ(
        changes.shareExpiration?.currentValue
      );
    }
  }

  private getCurrentExpirationRangẹ(sharedTil: string): SHARE_LENGTH {
    function roundToHour(ms: number): number {
      return Number((ms / 3600000).toFixed());
    }
    let remainingTime: number = roundToHour(Date.parse(sharedTil) - Date.now());
    if (remainingTime >= roundToHour(this.periodLength.threemonths))
      return SHARE_LENGTH.THREEMONTHS;
    else if (remainingTime >= roundToHour(this.periodLength.month))
      return SHARE_LENGTH.MONTH;
    else if (remainingTime >= roundToHour(this.periodLength.twoweeks))
      return SHARE_LENGTH.TWOWEEKS;
    else if (remainingTime >= roundToHour(this.periodLength.week))
      return SHARE_LENGTH.WEEK;
    else return SHARE_LENGTH.DAY;
  }
}
